import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, FormControl, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import DelimiterDialog from '../../TemplateProperties/DelimiterDialog';
import { debounce } from 'lodash';
import { stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import _ from 'lodash';

const BridgeGateSocket = ({ connectionDetails, handleBodyContent, screen, disableControl, changedKeys={}, useConnection, repoPDC }) => {
    const { t } = useTranslation();
    const [port, setPort] = useState('');
    const [dataTerminator, setDataTerminator] = useState(null);
    const [dialogState, setDialogState] = useState(false);
    const [outTime, setOutTime] = useState(0);
    const [socketAlive, setSocketAlive] = useState(false);
    const [singleConnection, setSingleConnection] = useState(false);
    const [ssl, setSsl] = useState(false);
    const [sendSynResp, setSendSynResp] = useState(false);
    // const [decompression, setDecompression] = useState(false);
    const [content, setContent] = useState(null);
    const [workflowSessionModal, setWorkflowSessionModal] = useState({open: false, isFirstTime: false});

    const handleDataTerminator = (val) => {
        if (val) {
            setDataTerminator(delimDisplay(val, true));
            onInputChange('EOD_TERMINATOR', (val));
        } else {
            onInputChange('EOD_TERMINATOR', (val));
            setDataTerminator(val)
            
        }
    }

    const delimDisplay = (val, modal) => {
        // Display values in certain ways depending on a few specific conditions:
        // - If no delim val -> 'No Delimiter Chosen'.
        // - Replace 'CR' and 'LF' (ascii 13 and 10) OR '%0D' '%0A' -> display 'CR', 'LF', 'CRLF' in latin characters.
        // - If val is one or two char length -> display 'ASCII 42 (*)' delimited by comma.
        // - else -> display the decoded string (even if it's just empty chars ?)
        if (val === undefined) return '';
        // if (!modal) {
        //     if (typeof val === 'boolean' || val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
        // }
        if (val === "CR" || val === "%0D" || val === "\r") return "CR";
        if (val === "LF" || val === "%0A" | val === "\n") return "LF";
        if (val === "CRLF" || val === "%0D%0A"|| val === "\r\n") return "CRLF";

        try { val = decodeURIComponent(val) }
        catch (e) {
            //case - malformed URI
            //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
        }
        return val.length < 3 ?
            val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ')
            : val;
    }

    const onInputChange = (name, value) => {
        if(screen === 'GET_DATA'){
            setContent({[name]:value})
        }
       else setContent((prev) => {
            return { ...prev, [name]: value };
        });
    }
   
   // Helper function to calculate font weight
    const getFontWeight = (control, currentValue, connectionDetails,useConnection) => {
        if (control === "TIMEOUT" && currentValue === "0") return "normal";
        return ((repoPDC?.[control] !== currentValue) &&
          useConnection === "preDefined")
        ? "bold"
        : "normal";
    };
    const fontWeights = useMemo(() => {
        return {
          TIMEOUT: getFontWeight("TIMEOUT", outTime, connectionDetails, useConnection),
          PORT: getFontWeight("PORT", port, connectionDetails, useConnection),
          // Add more fields as needed
        };
      }, [outTime, port, connectionDetails, useConnection]);
      
    const debouncedContentUpdate = debounce(handleBodyContent, 200);

    useEffect(() => {

        setPort(connectionDetails?.PORT || '');
        setDataTerminator(connectionDetails?.EOD_TERMINATOR ? delimDisplay(connectionDetails?.EOD_TERMINATOR) : "");
        setDialogState(false);
        setOutTime(connectionDetails?.TIMEOUT || "0");
        setSocketAlive(stringToBooleanConversion(connectionDetails?.KEEP_ALIVE));
        setSingleConnection(stringToBooleanConversion(connectionDetails?.USE_SINGLE_CONN));
        setSsl(stringToBooleanConversion(connectionDetails?.SSL));
        setSendSynResp(stringToBooleanConversion(connectionDetails?.SYNCHRONOUS))
        // setDecompression(stringToBooleanConversion(connectionDetails?.ZIP));
        setContent({ ...connectionDetails });
    }, [connectionDetails, connectionDetails?.OVERRIDE]);

    useEffect(() => {
       if(!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
    }, [content?.PORT, content?.TIMEOUT, content?.EOD_TERMINATOR]);

    useEffect(() => {
        if(!_.isEqual(content, connectionDetails)) handleBodyContent(content);
     }, [content?.KEEP_ALIVE, content?.USE_SINGLE_CONN,content?.SSL, content?.SYNCHRONOUS ]);

    return (
        <>  
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_PORT")}
                        type="text"
                        value={port}
                        sx={{ input: { fontWeight: fontWeights.PORT } }}

                       
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setPort(e.target.value)
                        }}
                        className={"width-100"}
                        name={"PORT"}
                        autoComplete="off"
                    />
                </FormControl>
                {screen && screen === 'GET_DATA' && 
                (<Button size='small' disabled={disableControl || false} variant='outlined' onClick={() => setWorkflowSessionModal({open: true, isFirstTime: true})} sx={{width: '40px', minWidth:'40px'}}>
                    <MoreHorizOutlined fontSize='small' />
                </Button>
               )}
            </div>
            <FormControl className='width-100' size='small'>
               <TextField
                 size='small'
                 variant='outlined'
                 className='width-100 delim-button'
                 disabled={disableControl || false}
                 label={t("LBL_EOD_TERMINATOR")}
                 value={dataTerminator ||  t("TXT_NO_DELIM_CHOSEN")}
                 onClick={() => setDialogState(true)}
                 InputProps={{
                    readOnly: true,
                    sx: { textAlign: 'center' },
                    inputProps: { style: { textAlign: 'center' } }
                 }}
               />
            </FormControl>
            <DelimiterDialog
                modalOpen={dialogState}
                close={() => setDialogState(false)}
                handleInput={handleDataTerminator}
                val={dataTerminator || ''}
                name={'EOD_TERMINATOR'}
                from={'EOD_TERMINATOR'}
            />
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_TIMEOUT")}
                    type="number"
                    disabled={disableControl || false}
                    value={outTime}
                    sx={{ input: { fontWeight: fontWeights.TIMEOUT } }}

                    onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = inputValue.replace(/\D/g, '');
                        if (numericValue.length <= 9) {
                            setOutTime(numericValue);
                            onInputChange(e.target.name, numericValue);
                        }
                    }} 
                    className={"width-100"}
                    name={"TIMEOUT"}
                    autoComplete="off"
                />
            </FormControl>
            <div className='flex flex-wrap'>
                <TPCheckbox
                    label={t("BTN_USE_KEEP_ALIVE")}
                    disabled={disableControl || false}
                    checked={socketAlive}
                    handleCheck={(checked) => {
                        onInputChange('KEEP_ALIVE', stringifyJSONAttributes(checked));
                        setSocketAlive(checked);
                    }}
                />
                <TPCheckbox
                    label={t("USE_SINGLE_CONNECTION")}
                    checked={singleConnection}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                        onInputChange('USE_SINGLE_CONN', stringifyJSONAttributes(checked));
                        setSingleConnection(checked);
                    }}
                />
                {/* <TPCheckbox
                    label={t("BTN_USE_ZIP_DECOMPRESS")}
                    checked={decompression}
                    disabled={true}
                    handleCheck={(checked) => {
                        onInputChange('ZIP', stringifyJSONAttributes(checked));
                        setDecompression(checked);
                    }}
                /> */}
                <TPCheckbox
                    label={t("BTN_SSL")}
                    checked={ssl}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                        onInputChange('SSL', stringifyJSONAttributes(checked));
                        setSsl(checked);
                    }}
                />
                {(screen && screen === 'GET_DATA') && <TPCheckbox
                    label={t("BTN_SEND_SYNC_RESPONSE")}
                    checked={sendSynResp}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                        onInputChange('SYNCHRONOUS', stringifyJSONAttributes(checked));
                        setSendSynResp(checked);
                    }}
                />}
            </div>
            <WorkflowSessionModal
                valueLabel={t("LBL_PORT")}
                showAccountData={true}
                showCallingWorkflow={true}
                showDateAndTime={true} 
                showSystemData={true}
                showWorkflowSession={true}
                openModal={workflowSessionModal} 
                setModalOpen={setWorkflowSessionModal}
                handleClose={()=>setWorkflowSessionModal({open: false, isFirstTime: false})}
                initialValue={port}
                valuesHandler={(value) => {
                    onInputChange("PORT", value)
                    setPort(value)
                }}
            />
        </>
    )
}

export default BridgeGateSocket

/** Props Description
 * connectionDetails - info about connection(or control values)
 * handleBodyContent - function to update connection details
 * screen - Parent Component
 * disableControl - used for screens like Get data properties to hide/show controls based on override pdc connection value
 * changedKeys - object that hold connection properties that are changed for Repository pdc (used to show changes in bold)
 * useConnection - (preDefined/current) used to show control values in bold
 */